<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="CMSPromotions")
    template(v-if="$route.name === 'CMSPromotionNew'")
      h1.title Neues Angebot
      .sub-headline Bitte füllen Sie alle erforderlichen Felder aus.
    template(v-if="$route.name === 'CMSPromotionEdit' && formData.id")
      h1.title {{formData.name}}
      .sub-headline Zuletzt bearbeitet am {{formatDate(formData.updatedAt)}} Uhr
  
    .guest-wrapper.margin-top
      ValidationObserver(v-slot="{ handleSubmit }")
        .two-column
          .column
            .card
              .top
              .main.padding
                  .form
                    h2.title.is-6 Allgemein
                    ValidationProvider(name="Name" rules="required" v-slot="{ errors, valid }") 
                      b-field(label="Name" label-position="on-border"
                              :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        b-input(v-model="formData.name")
                    ValidationProvider(name="Beschreibung" rules="required" v-slot="{ errors, valid }") 
                      b-field(label="Beschreibung" label-position="on-border"
                              :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        b-input(v-model="formData.description" type="textarea" maxlength="1000")
                    ValidationProvider(name="URL" rules="required" v-slot="{ errors, valid }") 
                      b-field(label="URL" label-position="on-border"
                              :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        b-input(v-model="formData.url")
                      b-tag https://www.[Ihre-Domain]/angebote/{{formData.url}}
                      .spacer.md

                    div(v-if="$route.name === 'CMSPromotionEdit' && dateRange && dateRange.start")
                      h2.title.is-6 Details
                      ValidationProvider(name="Von" rules="required" v-slot="{ errors, valid }") 
                        b-field(label="Von" label-position="on-border"
                                :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors" expanded)
                          v-date-picker(is-expanded is-range v-model="dateRange")

                      .spacer.sm
                      b-field(grouped)
                        ValidationProvider(name="Min. Nächte" rules="required" v-slot="{ errors, valid }") 
                          b-field(label="Min. Nächte" label-position="on-border"
                                  :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                            b-input(v-model="formData.minNights")
                        .spacer.sm
                        b-field(label="Angebotstyp" label-position="on-border")
                          b-select(v-model="promotionType")
                            option(value="freeNights") 🎁 ÜN Gratis
                            option(value="discountPercentage") 🎁 ÜN Rabatt in %
                      b-field(grouped v-if="promotionType === 'freeNights'")
                        ValidationProvider(name="Gratis Nächte" rules="required" v-slot="{ errors, valid }") 
                          b-field(label="Gratis Nächte" label-position="on-border"
                                  :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                            b-input(v-model="formData.freeNights" @keypress.native="isNumber($event)")
                        .spacer.sm
                        ValidationProvider(name="Checkbox" rules="required" v-slot="{ errors, valid }") 
                          b-field(:type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                            b-checkbox(v-model="formData.isFairMode") <b>Super Fair: </b> Wenn z.B. {{formData.minNights*3}} Nächte gebucht werden, werden {{formData.freeNights*3}} Nächte nicht berechnet.
                            
                      b-field(grouped v-else)
                        ValidationProvider(name="Rabatt in %" rules="required" v-slot="{ errors, valid }") 
                          b-field(label="Rabatt in %" label-position="on-border"
                                  :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                            b-input(v-model="formData.discountPercentage" @keypress.native="isNumber($event)")
                        .spacer.sm
                        ValidationProvider(name="Checkbox" rules="required" v-slot="{ errors, valid }") 
                          b-field(:type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                            b-checkbox(v-model="formData.isFairMode") <b>Super Fair: </b> Wenn min. Nächte erfüllt sind, gilt der Rabatt auch für Tage außerhalb des Angebots
                    
                    h2.title.is-6 Titelbild
                    img.preview(:src="formData.imageThumbnailUrl")
                    ValidationProvider(name="Titelbild" :rules="formData.imageThumbnailUrl ? '' : 'required'" v-slot="{ errors, valid }") 
                      b-field(:type="{ 'is-danger': errors[0], 'is-success': valid }")
                        file-pond(
                        name="files",
                        ref="pond",
                        label-idle="Laden Sie ein Titelbild hoch ...",
                        v-bind:allow-multiple="false",
                        accepted-file-types="image/jpeg, image/png",
                        v-model="files")
                      .error(v-if="!files[0] && !formData.imageThumbnailUrl") Sie müssen ein Titelbild auswählen

                    .button-wrapper.margin-top.right(v-if="$route.name === 'CMSPromotionEdit' && formData.id")
                      b-button(type="is-light" @click="$router.push({name: 'CMSPromotions'})") Abbrechen
                      b-button(type="is-primary" @click="handleSubmit(createPromotion)") Aktualisieren
            
          .column
            .card(v-if="$route.name === 'CMSPromotionEdit' && formData.id")
              .top
                .left
                  .card-headline Objekte
                  .card-description Hier finden Sie alle Objekte des Angebots.
                .right
                  .button-wrapper      
                    RentObjectPickerModal(:disabledIds="disabledIds" :rentObjectTypeUUIDs="['HOUSE', 'APPARTMENT']" @selected="checkedRows => addObject(checkedRows)")
              .main.padding
                b-table(:data="formData.rentObjectPromotions"
                  default-sort-direction="asc"
                  default-sort="date")
                  b-table-column(field='thumbnail' label='Vorschau' v-slot="props")
                    img(:src="props.row.rentObject.rentObjectImages[0] ? props.row.rentObject.rentObjectImages[0].thumbnailUrl : 'https://via.placeholder.com/150'")
                  b-table-column(field='name' label='Mietobjekt' sortable v-slot="props")
                    .r-name {{ props.row.rentObject.name }}
                    .spacer.sm
                    b-button(type="is-text" size="is-small" icon-left="close" @click="deleteObject(props.row.id)") Entfernen
            div(v-else)
              .card
                .top
                .main.padding
                  h2.title.is-6 Details
                  ValidationProvider(name="Von" rules="required" v-slot="{ errors, valid }") 
                    b-field(label="Von" label-position="on-border"
                            :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors" expanded)
                      v-date-picker(is-expanded is-range v-model="dateRange")

                  .spacer.sm
                  b-field(grouped)
                    ValidationProvider(name="Min. Nächte" rules="required" v-slot="{ errors, valid }") 
                      b-field(label="Min. Nächte" label-position="on-border"
                              :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        b-input(v-model="formData.minNights")
                    .spacer.sm
                    b-field(label="Angebotstyp" label-position="on-border")
                      b-select(v-model="promotionType")
                        option(value="freeNights") 🎁 ÜN Gratis
                        option(value="discountPercentage") 🎁 ÜN Rabatt in %
                  b-field(grouped v-if="promotionType === 'freeNights'")
                    ValidationProvider(name="Gratis Nächte" rules="required" v-slot="{ errors, valid }") 
                      b-field(label="Gratis Nächte" label-position="on-border"
                              :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        b-input(v-model="formData.freeNights" @keypress.native="isNumber($event)")
                    .spacer.sm
                    ValidationProvider(name="Checkbox" rules="required" v-slot="{ errors, valid }") 
                      b-field(:type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        b-checkbox(v-model="formData.isFairMode") <b>Super Fair: </b> Wenn z.B. {{formData.minNights*3}} Nächte gebucht werden, werden {{formData.freeNights*3}} Nächte nicht berechnet.
                        
                  b-field(grouped v-else)
                    ValidationProvider(name="Rabatt in %" rules="required" v-slot="{ errors, valid }") 
                      b-field(label="Rabatt in %" label-position="on-border"
                              :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        b-input(v-model="formData.discountPercentage" @keypress.native="isNumber($event)")
                    .spacer.sm
                    ValidationProvider(name="Checkbox" rules="required" v-slot="{ errors, valid }") 
                      b-field(:type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        b-checkbox(v-model="formData.isFairMode") <b>Super Fair: </b> Wenn min. Nächte erfüllt sind, gilt der Rabatt auch für Tage außerhalb des Angebots
                  
                  .button-wrapper.margin-top.right
                    b-button(type="is-light" @click="$router.push({name: 'CMSPromotions'})") Abbrechen
                    b-button(type="is-primary" @click="handleSubmit(createPromotion)") Angebot erstellen

</template>

<script>
import {DateTime} from "luxon";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import RentObjectPickerModal from "@/components/molecules/RentObjectPickerModal.vue";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

export default {
  components: {
    FilePond,
    RentObjectPickerModal
  },
  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      dateRange: null,
      promotion: null,
      promotionType: 'freeNights', // freeNights or discountPercentage
      formData: {
        name: null,
        description: null,
        startDate: null,
        endDate: null,
        minNights: 7,
        freeNights: 0,
        discountPercentage: 0,
        url: null,
        isFairMode: false
      },
      files: []
    };
  },
  async mounted() {
    this.mount();
  },
  computed: {
    disabledIds() {
      const ids = [];
      this.formData.rentObjectPromotions.forEach(r => {
        ids.push(r.rentObjectId);
      });
      return ids;
    }
  },
  methods: {
    async mount() {
      const loadingComponent = this.$buefy.loading.open();

      if (this.$route.name === "CMSPromotionEdit" && this.id) {
        this.promotion = await this.$store.dispatch("promotions/findOne", { id: this.id });
        this.formData = {
          ...this.formData,
          ...this.promotion
        };

        if (this.formData.discountPercentage) {
          this.promotionType = 'discountPercentage';
        }

        this.dateRange = {
          start: new Date(this.formData.startDate),
          end: new Date(this.formData.endDate)
        };
      }
      loadingComponent.close();
    },
    async createPromotion() {
      if (this.id) {
        const loadingComponent = this.$buefy.loading.open();
        this.formData.startDate = DateTime.fromJSDate(this.dateRange.start).toISODate();
        this.formData.endDate = DateTime.fromJSDate(this.dateRange.end).toISODate();

        if (this.promotionType === 'freeNights') {
          this.formData.discountPercentage = null;
        } else {
          this.formData.freeNights = null;
        }

        const rawFiles = this.$refs.pond.getFiles();
        let files = [];
        for (let i = 0; i < rawFiles.length; i += 1) {
          files.push(rawFiles[i].file);
        }
        const updatedData = await this.$store.dispatch("promotions/update", {
          id: this.id,
          formData: this.formData,
          files,
        });
        this.formData = {
          ...this.formData,
          ...updatedData
        };
        this.$refs.pond.removeFiles();
        this.files = [];
        loadingComponent.close();
      } else {
        const loadingComponent = this.$buefy.loading.open();
        this.formData.startDate = DateTime.fromJSDate(this.dateRange.start).toISODate();
        this.formData.endDate = DateTime.fromJSDate(this.dateRange.end).toISODate();

        if (this.promotionType === 'freeNights') {
          this.formData.discountPercentage = null;
        } else {
          this.formData.freeNights = null;
        }

        const rawFiles = this.$refs.pond.getFiles();
        let files = [];
        for (let i = 0; i < rawFiles.length; i += 1) {
          files.push(rawFiles[i].file);
        }
        await this.$store.dispatch("promotions/create", {
          id: this.id,
          formData: this.formData,
          files,
        });
        this.$refs.pond.removeFiles();
        this.files = [];
        loadingComponent.close();
      }
    },
    async addObject(rows) {
      const loadingComponent = this.$buefy.loading.open();
      await this.$store.dispatch("rentObjectPromotions/create", { rentObjects: rows, promotionId: this.id });
      this.mount();
      loadingComponent.close();
    },
    async deleteObject(id) {
      const loadingComponent = this.$buefy.loading.open();
      await this.$store.dispatch("rentObjectPromotions/delete", { id });
      this.mount();
      loadingComponent.close();
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.toLocaleString({
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      });
    },
    simpleDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.toLocaleString({
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.status-wrapper {
  margin-top: $xs-space;
}

.button-wrapper {
  margin: $xs-space 0 $sm-space 0;
}
.two-column {
  display: flex;
  justify-content: space-between;
}
.r-name {
  font-weight: 500;
}
.label {
  font-weight: 600;
  margin-top: $sm-space;
  margin-bottom: 0;
  &:not(:last-child) {
    margin-bottom: 0;
  }
}

.preview {
  border-radius: 3px;
  box-shadow: $shadow-lg
}
</style>